import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import classes from './PlanAllocationCategory.css';
import {getIndexProtectorLabel} from "../../shared/common";
import {connect} from "react-redux";

const DEFAULT_INDEX_PROTECTOR_CATEGORY = "Index Protector 7";

class PlanAllocationCategory extends Component {

    state = {
        expanded: false
    };

    toggleExpand = () => {

        let newState = Object.assign({}, this.state);
        newState.expanded = !newState.expanded;
        this.setState(newState);
    };

    render() {

        console.log("INDEX PROTECTOR: ", this.props.indexProtector);

        let allocationCategoryClasses = ["allocationCategory"];

        let isIE = false;

        if(navigator.userAgent.indexOf('MSIE')!==-1
            || navigator.appVersion.indexOf('Trident/') > 0){
            isIE = true;
        }

        let plusStyle = {
            display: "none"
        };

        let minusStyle = {
            display: "inline"
        };

        if (! (this.state.expanded || isIE) ) {
            plusStyle = {
                display: "inline"
            };

            minusStyle = {
                display: "none"
            };

            if (!this.props.displayMode) allocationCategoryClasses.push("collapse");
        }

        if (isIE) {
            plusStyle = {
                display: "none"
            };

            minusStyle = {
                display: "none"
            };
        }

        let filteredAssets = this.props.category.children;

        if (this.props.filterZero) {
            filteredAssets = this.props.category.children.filter((asset) => {
                return asset.value > 0.0;
            });
        }

        let assetsList = filteredAssets.map((asset) => {

            console.log("CATEGORY: ", this.props.category.name);
            console.log("INDEX PROTECTOR: ", this.props.indexProtector);
            console.log("DEFAULT: ", DEFAULT_INDEX_PROTECTOR_CATEGORY);

            if ( ((this.props.companyName === "WELLS_FARGO" &&
                this.props.category.name === DEFAULT_INDEX_PROTECTOR_CATEGORY)) &&
                (asset.name === "S&P 500 Risk Control" || asset.name === "S&P U.S. Retiree" || asset.name === "iShares U.S. Real Estate")) {
                return null;
            }

            if (this.props.indexProtector == 5 && (asset.name === "S&P 500 Risk Control" || asset.name === "S&P U.S. Retiree" || asset.name === "iShares U.S. Real Estate")) {
                return null;
            }

            if (this.props.indexProtector == 4 && (asset.name === "First Trust Barclays Edge Index")) {
                return null;
            }

            let assetValue = null;

            if (this.props.editMode) {
                assetValue = (
                    <NumberFormat
                        onValueChange={(values) => this.props.updateAllocation({
                            categoryId: this.props.category.assetId,
                            assetId: asset.assetId,
                            value: values.value
                        })}
                        onClick={() =>  this.props.updateAllocation({
                            categoryId: this.props.categoryId,
                            assetId: asset.assetId,
                            value: ""
                        })}
                        onBlur={() =>  this.props.updateAllocation({
                            categoryId: this.props.categoryId,
                            assetId: asset.assetId,
                            value: "BLUR"
                        })}
                        value={asset.value}
                        displayType={'input'}
                        suffix={'%'}
                        decimalScale="1"
                        fixedDecimalScale="true"
                    />
                );
            } else {
                assetValue = (<span>{asset.value.toFixed(1)}%</span>);
            }


            if (this.props.displayMode) {
                plusStyle = {
                    display: "none"
                };

                minusStyle = {
                    display: "none"
                };
            }

            return (
                <div key={asset.assetId} className="asset">
                    <label>{asset.name}</label>
                    {assetValue}
                </div>
            );
        });

        let bgStyle = {
            backgroundColor: this.props.color,
        };

        let categoryTotal = this.props.category.value;
        if (categoryTotal.toFixed !== undefined) categoryTotal = categoryTotal.toFixed(1);

        const categoryName = this.props.category.name === DEFAULT_INDEX_PROTECTOR_CATEGORY ? getIndexProtectorLabel(this.props.indexProtector, true ) : this.props.category.name;
        return (
            <div className={allocationCategoryClasses.join(" ")}>
                <div style={bgStyle} className="title">
                    <div style={plusStyle} onClick={this.toggleExpand} className="assetHandle"><i className="fas fa-plus-circle"></i></div>
                    <div style={minusStyle} onClick={this.toggleExpand} className="assetHandle"><i className="fas fa-minus-circle"></i></div>
                    {categoryName}
                    <span>{categoryTotal}%</span>
                </div>
                <div className="assetList">
                    {assetsList}
                </div>
            </div>
        );

    }

}

const mapStateToProps = (state) => {
    return {
        companyName: state.globalState.companyName
    }
}

export default connect(mapStateToProps)(PlanAllocationCategory);



// WEBPACK FOOTER //
// ./src/containers/PlanAllocationCategory/PlanAllocationCategory.js